window.addEventListener('scroll', handleScroll);
window.addEventListener('load', handleScroll); // Check scroll position on page load

function handleScroll() {
    const menu = document.querySelector('header');
    const hasModalOpen = document.querySelector('.has-modal-open');
    const isHomePage = document.body.classList.contains('home');

    if (isHomePage && window.scrollY <= 50) {
        menu.classList.add('is-at-top');
    } else {
        menu.classList.remove('is-at-top');
    }

    if (window.scrollY > 20) { // Adjust scroll value as needed
        menu.classList.add('scrolled');
        menu.classList.remove('anim');
    } else {
        menu.classList.add('anim');
        menu.classList.remove('scrolled');
    }
}

// Optional: MutationObserver to handle dynamically added/removed 'has-modal-open' class
// MutationObserver for changes on the <html> tag
/*
const observer = new MutationObserver(() => {
  handleScroll(); // Ensure proper behavior when 'has-modal-open' changes on <html>
});

observer.observe(document.documentElement, {
  attributes: true, // Listen for attribute changes
  attributeFilter: ['class'] // Only observe class changes
});
*/
/*================ ANIMATE ============*/
if (navigator.userAgent.indexOf('Safari') != -1 && 
    navigator.userAgent.indexOf('Chrome') == -1) {
        document.body.className += " safari";
    }
document.addEventListener("DOMContentLoaded", function() {
    const fadeIns = document.querySelectorAll('.fade-in');
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
           
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    fadeIns.forEach(fadeIn => {
        if (isElementInViewport(fadeIn) || fadeIn.classList.contains('visible')) {
            fadeIn.classList.add('visible');
        } else {
            observer.observe(fadeIn);
        }
    });

    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.top < window.innerHeight &&
          rect.bottom > 0 &&
          rect.left < window.innerWidth &&
          rect.right > 0
        );
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    const root = document.documentElement;
    const sections = [...document.querySelectorAll('[data-component-list*="StaggeredFadeIn"]')];
    const initializedSwipers = new WeakSet();
    const observedSwipers = new WeakSet();

    function syncMotionClass() {
        root.classList.toggle("reduced-motion", prefersReduced.matches);
        root.classList.toggle("no-reduced-motion", !prefersReduced.matches);
    }

    function getStaggerContainer(section) {
        return section.querySelector(':scope > .wp-block-group__inner-container') || section;
    }

    function getSliderPostTemplateSwiper(section) {
        const slide = section.closest("swiper-slide");
        const swiper = slide?.closest("swiper-container");

        if (!swiper?.closest(".wp-block-gfd-slider-post-template-block")) {
            return null;
        }

        return swiper;
    }

    function isPartiallyInViewport(element) {
        const rect = element.getBoundingClientRect();

        return (
            rect.top < window.innerHeight &&
            rect.bottom > 0 &&
            rect.left < window.innerWidth &&
            rect.right > 0
        );
    }

    function prepareSection(section) {
        const container = getStaggerContainer(section);
        const items = [...container.children].filter((item) => !item.hasAttribute("hidden"));

        if (!items.length) {
            section.classList.add("staggered-end");
            return;
        }

        items.forEach((item, index) => {
            item.setAttribute("data-staggered-item", "");
            item.style.setProperty("--stagger-index", index);
        });

        section.classList.add("staggered-ready");
    }

    function isVisibleInsideSwiper(section, swiper) {
        const sectionRect = section.getBoundingClientRect();
        const swiperRect = swiper.getBoundingClientRect();

        return (
            sectionRect.top < swiperRect.bottom &&
            sectionRect.bottom > swiperRect.top &&
            sectionRect.left < swiperRect.right &&
            sectionRect.right > swiperRect.left
        );
    }

    function resetSection(section) {
        section.dataset.swiperStaggerVisible = "false";
        section.classList.remove("staggered-end");
    }

    function playSection(section) {
        resetSection(section);
        window.requestAnimationFrame(() => {
            section.dataset.swiperStaggerVisible = "true";
            section.classList.add("staggered-end");
        });
    }

    function refreshSwiperSections(swiper) {
        const swiperSections = swiper.querySelectorAll('[data-component-list*="StaggeredFadeIn"]');

        if (!isPartiallyInViewport(swiper)) {
            swiperSections.forEach((section) => {
                resetSection(section);
            });
            return;
        }

        swiperSections.forEach((section) => {
            if (prefersReduced.matches) {
                section.dataset.swiperStaggerVisible = "true";
                section.classList.add("staggered-end");
                return;
            }

            if (isVisibleInsideSwiper(section, swiper)) {
                if (section.dataset.swiperStaggerVisible !== "true") {
                    playSection(section);
                }
                return;
            }

            resetSection(section);
        });
    }

    function bindSwiperRefresh(swiper) {
        if (initializedSwipers.has(swiper)) {
            return;
        }

        initializedSwipers.add(swiper);

        const handleRefresh = () => {
            refreshSwiperSections(swiper);
        };

        swiper.addEventListener("swiperslidechange", handleRefresh);
        swiper.addEventListener("swipertransitionend", handleRefresh);

        window.requestAnimationFrame(handleRefresh);
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("staggered-end");
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            rootMargin: "0px",
            threshold: 0
        }
    );

    const swiperObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    refreshSwiperSections(entry.target);
                }
            });
        },
        {
            rootMargin: "0px",
            threshold: 0
        }
    );

    syncMotionClass();
    prefersReduced.addEventListener("change", syncMotionClass);

    sections.forEach((section) => {
        prepareSection(section);

        const swiper = getSliderPostTemplateSwiper(section);

        if (swiper) {
            bindSwiperRefresh(swiper);
            if (!observedSwipers.has(swiper)) {
                swiperObserver.observe(swiper);
                observedSwipers.add(swiper);
            }
            return;
        }

        if (prefersReduced.matches || isPartiallyInViewport(section)) {
            section.classList.add("staggered-end");
            return;
        }

        observer.observe(section);
    });
});

/*=== NAVIGATION ===*/

document.querySelectorAll('.wp-block-navigation-submenu').forEach(submenu => {
    submenu.addEventListener('click', function(event) {
      // Get the width and height of the submenu
      const submenuWidth = submenu.offsetWidth;
      const submenuHeight = submenu.offsetHeight;
  
      // Calculate the position for the right 30% of the submenu
      const right30PercentPosition = submenuWidth * 0.7; // 70% of the submenu width, where 30% will be clickable
  
      // Define the top 50px range for click detection
      const top50pxPosition = submenu.getBoundingClientRect().top + 50;
  
      // Check if the click occurred within the right 30% of the submenu and within the top 50px of the height
      if (
        event.clientX > submenu.getBoundingClientRect().left + right30PercentPosition &&
        event.clientY < top50pxPosition
      ) {
        submenu.classList.toggle('active-submenu');  // Toggle the active class
      }
    });
  });


  /*==== TAble Block item =====*/

  document.querySelectorAll('.wp-block-gfd-services-table-item-block').forEach(item => {
    item.addEventListener('click', function() {
      const link = item.querySelector('a'); // Find the first <a> inside the div
      if (link) {
        window.location.href = link.href; // Redirect to the <a>'s href
      }
    });
  });

  /*====== GCLID ========*/

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function getParam(p){
    var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  document.addEventListener('DOMContentLoaded', function() {
    var gclid = getParam('gclid');

    if(gclid){
      var gclsrc = getParam('gclsrc');
      setCookie('wordpress_gclid', gclid, 90);
      if(!gclsrc || gclsrc.indexOf('aw') !== -1){    
      }
    }
    // List of IDs to apply the gclid value
    var gclidFields = document.querySelectorAll('#gform_fields_1 #field_1_12 #input_1_12, #gform_fields_2 #field_2_9 #input_2_9, #gform_fields_4 #field_4_11 #input_4_11');

    gclidFields.forEach(function(field) {
      if (field) {
        field.value = getCookie('wordpress_gclid');
      }
    });
  });

/*====== COUNT DOWN ======*/
function animateCountUpForClass(query, duration = 2000, concat = '') {
  const elements = document.querySelectorAll(query);

  elements.forEach((element) => {
    // Extract numbers and ignore any non-numeric suffix
    const numberString = element.textContent.replace(/[^\d.,]/g, '').replace(/,/g, '');
    const target = parseInt(numberString, 10);

    let start = 0;
    const startTime = Date.now();

    function formatNumber(number) {
      return number.toLocaleString() + concat;
    }

    // Easing function (ease-out quadratic)
    function easeOutQuad(t) {
      return t * (2 - t);
    }

    function updateCount() {
      const elapsedTime = Date.now() - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const easedProgress = easeOutQuad(progress);

      start = Math.floor(easedProgress * target);
      element.textContent = formatNumber(start);

      if (progress < 1) {
        requestAnimationFrame(updateCount);
      } else {
        element.textContent = formatNumber(target); // Ensure the final value is exact
      }
    }

    element.textContent = '0' + concat; // Reset to 0 before starting
    updateCount();
  });
}
  
  // Call the function
  animateCountUpForClass('.no-percent .count-up strong', 3000); // Adjust duration as needed (in milliseconds)
  animateCountUpForClass('.percent .count-up strong', 3000, '%'); // Adjust duration as needed (in milliseconds)
